<div class="no-bg" style="height: 100%;min-height: 100%;">
  <router-outlet></router-outlet>
</div>
